import { format } from "date-fns";
import instance from "./config";
import page from "../services/pages.js";

export default {
  listAll: async function (jwt: string, query = {}) {
    const searchParams = page.makeListServiceQueryParams({ ...query });
    try {
      const response = instance.get(`/projects?${searchParams.toString()}`, {
        headers: {
          authorization: `Bearer ${jwt}`,
        }
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  getStatus: async function (jwt: string, id: number) {
    try {
      const response = instance.get(`/projects/${id}/status`, {
        headers: {
          authorization: `Bearer ${jwt}`,
        },
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  getHistory: async function (id, start, end, jwt: string, range = null) {
    try {
      const params = {
        start: null,
        end: null,
        range,
      };
      if (start) params.start = format(start, "yyyy-MM-dd");
      if (end) params.end = format(end, "yyyy-MM-dd");
      const response = instance.get(`/projects/${id}/history`, {
        headers: {
          authorization: `Bearer ${jwt}`,
        },
        params,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  getFromUser: async function (jwt: string, customer_id: string): Promise<any> {
    try {
      const { data } = await instance.get(`/projects/customer/${customer_id}`, {
        headers: {
          authorization: `Bearer ${jwt}`,
        },
        params: {
          is_active: true,
        }
      });
      if (data.success) return data.data;
      else return [];
    } catch (error) {
      return [];
    }
  },
  update: async function (jwt, param_obj) {
    try {
      const response = await instance.put("/projects", param_obj, {
        headers: {
          authorization: `Bearer ${jwt}`,
        },
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  updateLess: async function (jwt, param_obj) {
    try {
      const response = await instance.put("/projects/less", param_obj, {
        headers: {
          authorization: `Bearer ${jwt}`,
        },
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  points: async function (jwt, project_id, payload) {
    try {
      const response = await instance.put(
        `/projects/${project_id}/points`,
        payload,
        {
          headers: {
            authorization: `Bearer ${jwt}`,
          },
        }
      );
      return response;
    } catch (error) {
      throw error;
    }
  },
  getProject: async function (jwt, id) {
    try {
      const response = instance.get(`/projects/${id}`, {
        headers: {
          authorization: `Bearer ${jwt}`,
        },
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  getProducts: async function (jwt, id) {
    try {
      const response = instance.get(`/projects/${id}/products`, {
        headers: {
          authorization: `Bearer ${jwt}`,
        },
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  create: async function (jwt, payload) {
    try {
      const response = await instance.post("/projects", payload, {
        headers: {
          authorization: `Bearer ${jwt}`,
        },
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  getBillingHistory: async function (jwt, project_id) {
    try {
      const response = await instance.get(
        `/projects/${project_id}/billing_history`,
        {
          headers: {
            authorization: `Bearer ${jwt}`,
          },
        }
      );
      return response;
    } catch (error) {
      throw error;
    }
  },
  removeProduct: async function (jwt, project_id, project_product_id) {
    try {
      const { data } = await instance.delete(
        `/projects/${project_id}/${project_product_id}`,
        {
          headers: {
            authorization: `Bearer ${jwt}`,
          },
        }
      );
      return data;
    } catch (error) {
      throw error;
    }
  },
  delete: async function (jwt: string, project_id: number): Promise<any> {
    try {
      const { data } = await instance.delete(`/projects/${project_id}`, {
        headers: {
          authorization: `Bearer ${jwt}`,
        },
      });
      return data;
    } catch (error) {
      throw error;
    }
  },
  disabledMember : async function (jwt: string, project_id: number): Promise<any> {
    try {
      const { data } = await instance.delete(`/projects/members/${project_id}`, {
        headers: {
          authorization: `Bearer ${jwt}`,
        },
      });
      return data;
    } catch (error) {
      throw error;
    }
  },
  cancelSubscription: async function (
    jwt: string,
    project_id: number,
    period: string
  ): Promise<any> {
    try {
      const response = await instance.delete(
        `/projects/${project_id}/subscription`,
        {
          params: {
            period,
          },
          headers: {
            authorization: `Bearer ${jwt}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  getTeams: async function (jwt: string, project_id: number, { search = '', customer_id = '', is_active = '', company_id = '' }): Promise<any> {
    const searchParams = page.makeListServiceQueryParams({ search, customer_id, is_active, company_id});
    try {
      return await instance.get(`/projects/${project_id}/teams?${searchParams.toString()}`, {
        headers: {
          authorization: `Bearer ${jwt}`,
        },
      });
    } catch (error) {
      console.error("Error fetching project teams:", error);
      throw error;
    }
  },
  getBoards: async function (jwt: string, project_id: number, { search = '', is_active = '' }): Promise<any> {
    const searchParams = page.makeListServiceQueryParams({ search, is_active});
    try {
      return await instance.get(`/projects/${project_id}/boards?${searchParams.toString()}`, {
        headers: {
          authorization: `Bearer ${jwt}`,
        },
      });
    } catch (error) {
      console.error("Error fetching project teams:", error);
      throw error;
    }
  },
};
